import { render, staticRenderFns } from "./SchoolTabs.vue?vue&type=template&id=6723613b&"
import script from "./SchoolTabs.vue?vue&type=script&lang=js&"
export * from "./SchoolTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports